import { createFileRoute } from '@tanstack/react-router';
import { LicencesPage } from '../../about/licences-page.js';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';

/** `/about/licences` (1.V-2 deliverable 3): guarded like every other authenticated route. */
export const Route = createFileRoute('/about/licences')({
  staticData: { crumb: 'Licenses' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: LicencesPage,
});
